<template>
  <div class="video-item">
    <video
      ref="player"
      class="video-video"
      :style="style"
      preload="metadata"
      webkit-playsinline
      playsinline
      x5-video-player-type="h5"
      x5-video-player-fullscreen="true"
      v-bind="$attrs"
      @click="togglePlay"
    ></video>

    <div class="video-cover">
      <slot></slot>
      <div class="play-icon">
        <img
          v-show="showPause"
          class="play-icon-inner"
          src="@/assets/img/play.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    objectPosition: {
      type: String,
      default: 'center',
    },
    showPause: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    style() {
      return {
        objectFit: 'contain',
        objectPosition: this.objectPosition,
      }
    },
  },
  methods: {
    isPlaying() {
      const video = this.$refs.player
      if (!video) return false
      return !(video.paused || video.ended || video.seeking)
    },
    togglePlay(evt) {
      const video = this.$refs.player
      if (this.isPlaying()) {
        this.$emit('update:showPause', true)
        video.pause()
      } else {
        this.$emit('update:showPause', false)
        video.play()
      }
    },
  },
}
</script>

<style lang="less">
.video-item {
  position: relative;
  width: 100%;
  height: 100%;

  .video-video {
    width: 100%;
    height: 100%;
  }
  .video-cover {
    position: absolute;
    pointer-events: none;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }
  .play-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-top: -0.36rem;
    margin-left: -0.56rem;
    width: 1.12rem;
    height: 0.72rem;
    font-size: 0;
    z-index: 2;
  }
  .play-icon-inner {
    width: 100%;
    height: 100%;
  }
}
</style>
